import { createSlice } from "@reduxjs/toolkit";
import { ClassroomResponseDto } from "../../shared/dtos/classroom/ClassroomResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const classroomSlice = createSlice({
  name: "classroom",
  initialState: getInitialCrudState<ClassroomResponseDto>(),
  reducers: { ...generateCrudReducers<ClassroomResponseDto>() },
});

export const classroomActions = classroomSlice.actions;
export default classroomSlice.reducer;
